import { Controller } from "stimulus";

export default class extends Controller {
    initialize() {
        import(/* webpackChunkName: "vehicles-favourited" */ '../components/VehiclesFavourited').then(module => {
            // console.log(this.element, module);
            module.default(this.element, { });
        })
    }
}